import { RootState } from "../../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import useUser from "../../../../hooks/user/useUser";
import { useFollowingCoach } from "../../../../hooks/specialist/useFollowingCoach";
import { FollowingPages } from "../../../../interfaces/hooks/IUseFollowingCoach";
import { ButtonProps } from "@mui/material";
import { setIsFollowingCoach } from "../../../../redux/pages/trainingPlanSlice";
import { followCoach, unfollowCoach } from "../../../../api/coaches";
import React from "react";
import { AppSecondaryButton } from "../../../global/ui/buttons";

type ListingCoachFollowBtnProps = ButtonProps;

export const ListingCoachFollowBtn = ({
  className,
}: ListingCoachFollowBtnProps) => {
  const userRedux = useSelector((state: RootState) => state.user.value);
  const coachRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData.user,
  );
  const isUserFollowing = useSelector(
    (state: RootState) => state.trainingPlan.isFollowingCoach,
  );
  const { user } = useUser();
  const dispatch = useDispatch();

  useFollowingCoach({ page: FollowingPages.LISTING });

  const handleClickButton = async () => {
    switch (isUserFollowing) {
      case true:
        dispatch(setIsFollowingCoach(false));
        await unfollowCoach(coachRedux.id, user?.token);

        break;

      case false:
        dispatch(setIsFollowingCoach(true));
        await followCoach(coachRedux.id, user?.token);

        break;
    }

    return null;
  };

  if (userRedux.loggedUser && isUserFollowing !== undefined) {
    return (
      <AppSecondaryButton
        onClick={() => void handleClickButton()}
        className={className}
      >
        {isUserFollowing ? "Following" : "Follow"}
      </AppSecondaryButton>
    );
  }
};
